import { A } from '@solidjs/router';
import { For, Show } from 'solid-js';
import IconBackArrow from '~/assets/images/common/backArrow.svg?component-solid';
import { useFeatureHighlights } from '~/contexts/global';
import { useMenu } from './MenuContext';
import type { MenuItem } from './types/menuItem';

interface SubMenuItemsProps {
  setIsSidebarOpen: (value: boolean) => void;
  containerHeight: string;
}

const SubMenuItems = (props: SubMenuItemsProps) => {
  const menu = useMenu();

  const returnParentMenu = () => {
    menu?.setActiveMenuItemId();
  };

  return (
    <div
      class="z-10 text-left text-white transition-transform duration-150"
      classList={{
        'translate-x-full w-0 p-0 h-full': !menu?.isCollapsed(),
        'translate-x-0 px-2 py-1 w-full h-full': menu?.isCollapsed(),
      }}>
      <div class="absolute inset-0 -z-10 rounded-l-lg bg-[var(--menu-panel-color)]" />
      <div
        class="relative flex h-15 cursor-pointer items-center gap-1 p-2.5 text-white/70 hover-allowed:hover:text-white"
        onClick={returnParentMenu}>
        <IconBackArrow class="scale-90" />
        {menu?.activeParentMenuTitle()}
        <div
          class="absolute bottom-0 h-0.5 w-full"
          style={{
            background:
              'linear-gradient(270deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.40) 50.84%, rgba(255, 255, 255, 0.00) 100%)',
          }}
        />
      </div>
      <ul>
        <For each={menu?.subMenuItems()}>{(subItem) => <SubMenuItem setIsSidebarOpen={props.setIsSidebarOpen} item={subItem} />}</For>
      </ul>
    </div>
  );
};

interface SubMenuItemProps {
  item: MenuItem;
  setIsSidebarOpen: (value: boolean) => void;
  onNavigate?: (e: MouseEvent) => void;
}

export const SubMenuItem = (props: SubMenuItemProps) => {
  const menu = useMenu();
  const { pulse } = useFeatureHighlights();

  const clickHandler = (e: MouseEvent) => {
    if (window.innerWidth <= 767) {
      props.setIsSidebarOpen(false);
    }
    props.onNavigate?.(e);
  };

  return (
    <li
      id={menu?.getMenuItemId(props.item)}
      class="my-2 box-border w-full rounded-md border border-transparent duration-200"
      classList={{
        'bg-[var(--menu-active-color)] font-semibold': menu?.isSelected(props.item),
        'hover-allowed:hover:border-[var(--menu-active-color)]': !menu?.isSelected(props.item),
      }}
      onClick={clickHandler}>
      <A id={menu?.getMenuItemId(props.item, true)} class="flex items-center gap-2 p-2.5" href={props.item.realPath || props.item.path}>
        {props.item.text}
        <Show when={props.item.hasHighlight}>
          <span class="relative flex size-2">
            <Show when={pulse()}>
              <span class="absolute -inset-0.5 animate-[ping_1.6s_ease-out_infinite] rounded-full bg-orange-400 opacity-75" />
            </Show>
            <span class="relative inline-flex size-2 rounded-full bg-orange-500" />
          </span>
        </Show>
      </A>
    </li>
  );
};

export default SubMenuItems;
